import { Link, useNavigate } from "react-router-dom";

function Navbar({ cartCount, user, setUser }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
    navigate("/login");
  };

  return (
    <nav className="bg-white border-b border-gray-100 px-6 sm:px-10 py-4 flex justify-between items-center sticky top-0 z-50 backdrop-blur-md bg-opacity-90">
      <Link to="/" className="text-xl font-bold tracking-tight text-gray-900 group flex items-center gap-2">
        <div className="w-6 h-6 bg-black rounded-sm flex items-center justify-center group-hover:scale-105 transition-transform">
          <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
        </div>
        ShopSwift
      </Link>

      <div className="flex items-center space-x-6 sm:space-x-8 text-sm font-medium text-gray-600">
        <Link to="/" className="hover:text-black transition-colors py-1">Catalog</Link>
        
        {user && user.isAdmin && (
          <Link to="/admin/orders" className="hover:text-black transition-colors py-1 flex items-center">
            <span className="w-1.5 h-1.5 bg-red-500 rounded-full mr-1.5"></span>
            Admin
          </Link>
        )}
        
        <Link to="/cart" className="relative group flex items-center hover:text-black transition-colors py-1">
          <svg className="w-5 h-5 mr-1.5 group-hover:translate-y-[-1px] transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
          </svg>
          Cart
          {cartCount > 0 && (
            <span className="ml-1.5 bg-black text-white text-[10px] font-bold px-2 py-0.5 rounded-full min-w-[20px] text-center scale-95 group-hover:scale-105 transition-transform">
              {cartCount}
            </span>
          )}
        </Link>

        <div className="h-4 w-[1px] bg-gray-200"></div>

        {user ? (
          <div className="flex items-center space-x-4">
            <span className="text-gray-500 hidden sm:inline font-normal">
              Hi, <strong className="font-semibold text-gray-800">{user.name}</strong>
            </span>
            <button
              onClick={handleLogout}
              className="bg-gray-100 hover:bg-gray-200 text-gray-800 px-3.5 py-1.5 rounded-md text-xs font-semibold transition-all"
            >
              Sign Out
            </button>
          </div>
        ) : (
          <div className="flex items-center space-x-3">
            <Link
              to="/login"
              className="text-gray-700 hover:text-black transition-colors text-xs font-semibold px-2 py-1"
            >
              Sign In
            </Link>
            <Link
              to="/register"
              className="bg-black hover:bg-gray-800 text-white px-3.5 py-1.5 rounded-md text-xs font-semibold transition-all shadow-sm"
            >
              Sign Up
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
